module.exports = __webpack_public_path__ + "static/img/baoxian1.c5417247.png";